import { BoxProps, css, styled } from '@withjoy/joykit';
import { Eye } from '@withjoy/joykit/icons';

export const EyeIcon = styled(Eye)`
  :hover {
    color: ${({ theme }) => theme.colors.mono8};
  }
  &.active,
  :active {
    color: ${({ theme }) => theme.colors.mono14};
  }
`;

export const OVERRIDE_HOVER_STYLES = css`
  :hover:not(:focus) {
    color: ${({ theme }) => theme.colors.mono8};
  }
`;

export const rootStyles: BoxProps = {
  _hover: {
    _after: {
      boxShadow: '0px 0 0px 1px #7139BF',
    },
  },
  _active: {
    color: 'mono14',
    borderColor: 'strokeDefault',
  },
  _focus: {
    color: 'mono14',
    borderColor: 'strokeDefault',
  },
  _focusWithin: {
    _after: {
      boxShadow: `0px 0 0px 2px #5F2698`,
    },
  },
};

export const inputStyles: BoxProps = {
  height: 56,
  fontSize: 16,
  _hover: {
    backgroundColor: 'mono1',
  },
  _active: {
    backgroundColor: 'mono1',
  },
};

export const controlStyles: BoxProps = {
  _hover: {
    color: 'mono12',
    backgroundColor: 'mono1',
  },
  _pressed: {
    color: 'mono13',
    backgroundColor: 'mono2',
  },
  _checked: {
    color: 'mono13',
    backgroundColor: 'mono2',
  },
};

export const endElementStyles: BoxProps = {
  pointerEvents: 'initial',
  cursor: 'pointer',
  paddingRight: 5,
};
